// extracted by mini-css-extract-plugin
export default {"error__container":"errorreport_error__container__HOmAl","error__icon":"errorreport_error__icon__Ld+vs"};